import { render, staticRenderFns } from "./RestAdapterEdit.vue?vue&type=template&id=4f51cbeb&scoped=true"
import script from "./RestAdapterEdit.vue?vue&type=script&lang=js"
export * from "./RestAdapterEdit.vue?vue&type=script&lang=js"
import style0 from "./RestAdapterEdit.vue?vue&type=style&index=0&id=4f51cbeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f51cbeb",
  null
  
)

export default component.exports